import { Component, EventEmitter, Input, Output, ViewEncapsulation, inject } from '@angular/core';
import { DictionaryService, SharedUiLibraryModule } from '@cudirect/shared-ui-library';
import { LenderService } from '@shared/service/lender/lender.service';

@Component({
  selector: 'cu-hang-tight-banner',
  templateUrl: './hang-tight-banner.component.html',
  styleUrls: ['./hang-tight-banner.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SharedUiLibraryModule]
})
export class HangTightBannerComponent {
  // Using inject pattern for dependencies
  private readonly dictionaryService = inject(DictionaryService);
  private readonly lenderService = inject(LenderService);

  /** Getting Task list as input */
  @Input() public show = false;

  @Output() public showChange: EventEmitter<boolean> = new EventEmitter();

  @Input() public type: HangTightType;

  public get isSuccess(): boolean {
    return this.type === 'success';
  }
  public get isWaiting(): boolean {
    return this.type === 'waiting';
  }
  public get isFailed(): boolean {
    return this.type === 'failed';
  }

  public get isInitiated(): boolean {
    return this.type === 'initiated';
  }

  public get getContactmessage(): string {
    const failedMessage = this.dictionaryService.read('hangtight/failedMsg').toString();
    const lenderContactPhone = this.lenderService.lenderData.contactPhone;
    if (lenderContactPhone) {
      const cleanPhoneNumber = lenderContactPhone.toString().replace(/\D/g, '');
      const formattedPhone =
        cleanPhoneNumber.length === 10
          ? cleanPhoneNumber.toString().replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3')
          : lenderContactPhone;
      // eslint-disable-next-line max-len
      const contactLink = `<a href='tel:${cleanPhoneNumber}' class='bl-font-weight--700 bl-font-size--16'>${formattedPhone}</a>`;
      return failedMessage.replace('#{lenderContactPhone}', contactLink);
    }
    return failedMessage.replace('at #{lenderContactPhone}', '');
  }

  /** close hangtight banner */
  public close() {
    this.showChange.emit(false);
  }
}
export type HangTightType = 'waiting' | 'initiated' | 'failed' | 'success';
